import { useCallback } from "react";

export interface SegmentedPipsProps {
  value: number;
  max: number;
  onChange: (next: number) => void;
  pipSize?: number;
  gap?: number;
  filledColor?: string;
  emptyColor?: string;
  disabled?: boolean;
  label?: string;
  ariaLabel?: string;
}

export function SegmentedPips({
  value,
  max,
  onChange,
  pipSize = 14,
  gap = 4,
  filledColor = "var(--paper-gold)",
  emptyColor = "var(--paper-rule)",
  disabled = false,
  label,
  ariaLabel,
}: SegmentedPipsProps) {
  const handlePipClick = useCallback(
    (i: number) => {
      if (i + 1 === value) {
        onChange(value - 1);
      } else {
        onChange(i + 1);
      }
    },
    [value, onChange],
  );

  const rootStyle: React.CSSProperties = disabled
    ? { opacity: 0.5, pointerEvents: "none", cursor: "not-allowed" }
    : {};

  return (
    <div style={rootStyle}>
      {label && (
        <div
          style={{
            font: "500 10px 'JetBrains Mono', monospace",
            letterSpacing: ".16em",
            textTransform: "uppercase",
            color: "var(--paper-ink-2)",
            marginBottom: "4px",
          }}
        >
          {label}
        </div>
      )}
      <div
        aria-label={ariaLabel}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: `${gap}px`,
        }}
      >
        {Array.from({ length: max }, (_, i) => (
          <div
            key={i}
            onClick={() => handlePipClick(i)}
            style={{
              width: `${pipSize}px`,
              height: `${pipSize}px`,
              background: i < value ? filledColor : emptyColor,
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
        ))}
      </div>
    </div>
  );
}
